export default __webpack_public_path__ + "14e18bb61268fecc4f4a0ec4374027ba.png";